import { render } from "./pop-comp.vue?vue&type=template&id=58b67cc2&scoped=true"
import script from "./pop-comp.vue?vue&type=script&lang=js"
export * from "./pop-comp.vue?vue&type=script&lang=js"

import "./pop-comp.vue?vue&type=style&index=0&id=58b67cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b67cc2"]])

export default __exports__